import React from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { BankIdLayout } from '../components/BankIdLayout';
import { BankIdEntry } from '../components/LocalBankIdDebug';
import { useAuth } from '../context/AuthContext';
import { authenticatedHomePath, requiresOnboarding } from '../utils/onboarding';
import { safeReturnPath } from '../utils/returnPath';
import { savedIdleReturnPath, clearIdleReturnPath } from '../services/sessionLifecycle';

export function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const { establishBankIdSession } = useAuth();
  const invitationId = params.get('invitation') || undefined;
  const returnPath = safeReturnPath((location.state as { from?: unknown } | null)?.from) ?? safeReturnPath(params.get('returnTo')) ?? savedIdleReturnPath();
  const registerPath = invitationId ? `/register?invitation=${encodeURIComponent(invitationId)}` : '/register';
  return <BankIdLayout below={<Link className="d-inline-block py-2" to={registerPath}>{t('auth.bankid.register')}</Link>}>
    <h1 className="h3 text-center">{t('auth.login.title')}</h1>
    <p className="text-muted text-center">{t('auth.bankid.loginDescription')}</p>
    {params.get('expired') === '1' && <p className="alert alert-info" role="status">{t('auth.login.idleExpired')}</p>}
    {invitationId && <p className="alert alert-info">{t('auth.bankid.invitation')}</p>}
    <BankIdEntry request={{ purpose: 'login', ...(invitationId ? { invitationId } : {}) }} onContinue={async response => {
      const user = await (response.user.syntheticTestActor || response.user.onboarding?.bankidAssuranceLevel === 'simulated' ? establishBankIdSession(response, 'tab') : establishBankIdSession(response));
      if (invitationId) sessionStorage.setItem('pendingInvitation', invitationId);
      clearIdleReturnPath();
      navigate(requiresOnboarding(user) ? '/onboarding' : invitationId ? `/invitations/${encodeURIComponent(invitationId)}/decision` : returnPath ?? authenticatedHomePath(user), { replace: true });
    }} />
    <p className="text-muted small text-center mt-4 mb-0"><Trans i18nKey="auth.bankid.loginTerms" components={{ terms: <Link to="/anvandarvillkor" /> }} /></p>
  </BankIdLayout>;
}
